import { Injectable, Injector, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../models/common.model';
import { firebaseEnv } from 'src/environments/firebase_env';

import { AuthServiceService } from './auth-service.service';
import { LocalServiceService } from './local-service.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root',
})
export class MemberNotificationService {
  private _baseUrl = environment.baseUrlAdmin;
  public notificationList = new Subject();
  public $notify: Subject<{ title: string; description: string }> =
    new Subject();
  clearNotificationById(id) {
    this.auth.updateNotificationIsRead(id).subscribe(() => {
      this.getNotification();
    });
  }
  constructor(
    private http: HttpClient,
    private localService: LocalServiceService,

    private sharedService: SharedService,
    private auth: AuthServiceService
  ) {
    this.notificationList.next([]);

    if (this.localService.getUser()?.token) {
      this.getNotification();
    }
  }
  private readonly FCM_TOKEN_KEY = 'USER_FCM_TOKEN';

  private lockDeviceRegistry: boolean = false;

  private async deleteFCToken(oldToken) {
    this.auth.delete_fcm_token(oldToken);
  }
  private async registerFirebaseServiceWorker() {

    if (
      'serviceWorker' in navigator &&
      !(await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      ))
    ) {
      try {
        const registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js',
          { scope: '/' }
        );
        console.log(
          'Service Worker registered with scope:',
          registration.scope
        );
        return registration;
      } catch (e) {
        console.error('Service worker registeration failed: ', e);
      }
    }
    return null;
  }
  public async registerDevice() {

    //console.log("Registering user devices and service worker")
    if (this.lockDeviceRegistry) {
      return;
    }

    if (
      'Notification' in window &&
      Notification.permission === 'granted' &&
      this.localService.getUser()?.token
    ) {
      this.lockDeviceRegistry = true;
      const oldFCMToken = localStorage.getItem(this.FCM_TOKEN_KEY);

      const registration = await this.registerFirebaseServiceWorker();
      if (!registration) {
        console.warn('Could not register service workers');
        this.lockDeviceRegistry = false;
      }

      const { initializeApp } = await import('firebase/app');
      const { getMessaging, getToken, onMessage } = await import(
        'firebase/messaging'
      );

      const firebaseApp = initializeApp(firebaseEnv.firebase.appConfig);
      const firebaseMessaging = getMessaging(firebaseApp);

      try {
        const token = await getToken(firebaseMessaging, {
          vapidKey: firebaseEnv.firebase.vapidKey,
          serviceWorkerRegistration: registration!,
        });

        if (token) {
          //console.log('Got fmc token', token, oldFCMToken);
          if (token != oldFCMToken && oldFCMToken) {
            //console.log('Deleting old fcm token', oldFCMToken);
            await this.deleteFCToken(oldFCMToken);
          } else {
            //console.log('New and old fcm tokens are the same');
          }
          this.auth.register_device(token).subscribe(
            (data) => {
              console.log('Device registered!');
              this.lockDeviceRegistry = false;
            },
            (err) => {
              this.lockDeviceRegistry = false;
              console.error(err);
            }
          );
          localStorage.setItem(this.FCM_TOKEN_KEY, token);
          onMessage(firebaseMessaging, function () {
            this.getNotification();
          });
          //firebaseMessaging.onTokenRefresh(this.registerDevice);
        } else {
          console.warn(
            'No registration token available. Request permission to generate one.'
          );
        }
      } catch (e) {
        console.error('Error while getting FCM token', e);
        this.lockDeviceRegistry = false;
      }
    } else {
      console.warn('Register device called when permission is not granted!');
    }
  }

  public getNotification(): void {
    this.http
      .get(`${this._baseUrl}getAllNotificationsForMember`)
      .subscribe((response: ApiResponse) => {
        this.notificationList.next(response.body);
      });
  }

  public clearNotification() {
    this.notificationList.next([]);
  }

  public notifyUser(title: string, description: string): void {
    this.$notify.next({ title: title, description: description });
  }
}
